export { alignUtterance, type UtteranceAlignment } from "#align-utterance";
export { isProducedTokenMatch } from "#is-produced-token-match";
export { reduceSentenceDrill, type SentenceDrillAction } from "#sentence-drill-reducer";
export {
  isSentenceDrillComplete,
  type SentenceDrillCommittedWordRating,
  sentenceDrillRatings,
  sentenceDrillRatingsOnCommit,
  sentenceDrillTokenDisplay,
  type SentenceDrillTokenDisplay,
  type SentenceDrillWordRating,
} from "#sentence-drill-selectors";
export {
  createSentenceDrillState,
  deriveCursorIndex,
  isTokenSettled,
  type SentenceDrillMode,
  type SentenceDrillState,
  type SentenceDrillTokenStatus,
} from "#sentence-drill-state";
export {
  isScorableToken,
  type ProducedToken,
  type SentenceDrillToken,
} from "#sentence-drill-token";
